var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var drawShapeOfPadDataTo2D = function (svg, group, data) {
    var attrs = {
        transform: editor_2d.toSVGutil.rotateTransform(data) + editor_2d.toSVGutil.translateTransform(data),
    };
    var g = svg.group(group, attrs);
    editor_2d.drawShapeDataTo2D(svg, g, data.shape());
	return g;
};

module.exports = drawShapeOfPadDataTo2D;
